import {Component, Optional, ViewContainerRef} from '@angular/core';
import {environment} from '../environments/environment';

import {TranslateService} from '@ngx-translate/core';
import {Log} from "ng2-logger";
import {NotificationService} from "@services/notification.service";
import {ToastsManager} from "@app/shared/util/toastr.service";
import {MsalBroadcastService, MsalService} from '@azure/msal-angular';
import {AuthenticationService} from '@app/authentication/services/authentication.service';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    _logger = Log.create(AppComponent.name);
    languageKey = "user-language";
    readonly msalEnabled = environment.msalEnable;
    msalExchangeLoading$: Observable<boolean>;

    constructor(private translate: TranslateService,
                private toastr: ToastsManager,
                private notificationService: NotificationService,
                vRef: ViewContainerRef,
                private authService: AuthenticationService,
                @Optional() private msalService?: MsalService,
                @Optional() private msalBroadcastService?: MsalBroadcastService) {
        translate.addLangs(['en', 'ro']);
        translate.setDefaultLang('en');

        translate.use(this.currentLanguage);
        toastr.setRootViewContainerRef(vRef);

        // Subscribe to MSAL exchange loading state
        this.msalExchangeLoading$ = this.authService.msalExchangeLoading$;

        if (!environment.mocks.offlineMode) {
            this.notificationService.subscribeToMessageSource();
        }

        // Handle MSAL redirect - must be called before any navigation
        if (this.msalEnabled && this.msalService) {
            this.msalService.instance.handleRedirectPromise().then((response) => {
                if (response?.account) {
                    this.msalService.instance.setActiveAccount(response.account);
                } else {
                    const accounts = this.msalService.instance.getAllAccounts();
                    if (accounts.length > 0) {
                        this.msalService.instance.setActiveAccount(accounts[0]);
                    }
                }
            }).catch((error) => {
                console.error('MSAL redirect error:', error);
            });
        }
    }

    get currentLanguage() {
        const storedLang = localStorage.getItem(this.languageKey);
        const browserLang = this.translate.getBrowserLang();
        return storedLang || browserLang;
    }
}
